export class IssueViewModel {
	readonly dateCode: string;
	readonly displayDate: number | undefined;

	nullableIsValid: boolean | undefined; // undefined = not loaded yet, true = valid, false = invalid/not available
	isSelected: boolean = false;

	constructor (dateString: string, displayDate: number) {
		this.dateCode = dateString;
		this.displayDate = displayDate;
	}
}
